import { RFIconProps } from "../types";

export default function LikeFilledIcon(props: RFIconProps) {
	return (
		<svg
			width="16"
			height="15"
			viewBox="0 0 16 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={props.className || "w-6 h-6"}
			onClick={props.onClick}
		>
			<path
				d="M11.3935 1.00183C10.7177 0.982354 10.0488 1.14981 9.45255 1.48774C8.85628 1.82566 8.35319 2.32241 7.99273 2.92914C7.63677 2.32148 7.13665 1.82364 6.5424 1.48541C5.94815 1.14718 5.2806 0.980429 4.60654 1.00183C4.11863 1.01173 3.63746 1.12457 3.19108 1.33379C2.74469 1.543 2.34203 1.84439 2.00656 2.22039C1.67109 2.59639 1.40953 3.03948 1.23712 3.52382C1.06471 4.00817 0.984902 4.52408 1.00235 5.04148C1.00235 9.74413 7.51314 13.8146 7.78927 13.9842C7.85591 14.0032 7.92609 14.0032 7.99273 13.9842C8.06405 14.0053 8.13942 14.0053 8.21073 13.9842C8.48686 13.8146 14.9976 9.74413 14.9976 5.04148C15.0151 4.52408 14.9353 4.00817 14.7629 3.52382C14.5905 3.03948 14.3289 2.59639 13.9934 2.22039C13.658 1.84439 13.2553 1.543 12.8089 1.33379C12.3625 1.12457 11.8814 1.01173 11.3935 1.00183Z"
				fill="currentColor"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
